export default __webpack_public_path__ + "5a24c18b60e31cd22f5ed52120d7ffbf.png";